import React, { Fragment } from 'react';
import moment from 'moment';
import { connect } from "react-redux";
import ViewHeader from '../view-header';
import { ACTIONS, EVENTS } from "react-joyride/es/constants";
import Joyride from 'react-joyride';
import BigCalendar from 'react-big-calendar';
import ReactTooltip from 'react-tooltip';
import ModalComponent from '../../../../components/Modal';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import AddBookingForm from '../../../../components/Home/addBookingForm';
import Notice from '../../../../components/Notification/newNotification';
import CustomModalBody from '../../../../components/Patient/CustomModalBody';
import { addPatient, getPatient, addBooking, deletePatient, editPatient, updateGuide, getCase, addPickup, getParentCases } from "./actions";
import '../../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import SubcaseForm from "../../../../components/SubCaseForm";
import SubcaseModalBody from "../../../../components/CreateSubcase";
import dates from 'react-big-calendar/lib/utils/dates';
import {globals} from '../../../../../../common/constants';
import Spinner from '../../../../components/Spinner';

//Icons
import IconSpinner from 'react-icons/lib/fa/spinner';

// Custom hooks

import {
    useDashboardEventList,
    useDashboardEventStyle,
    useDashboardUnitKey,
    useDashboardCaseBlockHeaderColor,
} from "../../CustomHooks";
import {getDefaultFilters} from "../../Admin/Patients/helpers";
import _ from "lodash";
import {
    resetDateTime,
    scrollTo,
    getLastLegalDays,
    findBusinessDays,
    formatDate, getNext8BusinessDays
} from "../../../../helpers";
import {
    ADD_CASE_SUCCESS_MESSAGE,
    SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE
} from "../../../../shared/constants";
import SubIconBlack from "../../../../images/sub_icon_black.svg";
import PatientsTable from "../PatientsTable";
import {getVacationDaysRequest} from "../../Admin/dashboard/actions";
import {setDate, startImageUploading} from "../../../../shared/redux/actions";
import { processImageUpdate } from "../../Admin/AdminCaseDetails/helpers";
import EditPasswordForm from "../../../../components/Profile/editPasswordForm";
BigCalendar.momentLocalizer(moment);

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.bridgesRef = React.createRef();
        let locationState = props.props.history.location.state;
        const locationStateDefaults = getDefaultFilters();
        locationState = _.assign(locationStateDefaults, locationState);
        this.state = {
            tableOption: {
                noDataText: 'No patient is available yet.',
                hideSizePerPage: true,
                onRowClick: (row) => this.linkToCasesPage(row),
                sizePerPage: 2,
                page: locationState.pageNumber,
                onSortChange: (field, order) => this.changeSortingOptions(field, order),
                onPageChange: (page) => this.handlePageChange(page)
            },
            showChangePasswordForm: false,
            showChangePasswordModal: false,
            newPatient: {
                first_name: '',
                last_name: '',
                notes: ''
            },
            validateNewPatient: {
                first_name: true,
                last_name: true
            },
            implantsPartObject: {
                1: { name: 'Impression coping ', number: 0 },
                2: { name: 'Impression screw ', number: 0 },
                3: { name: 'Lab analog ', number: 0 },
                4: { name: 'Prosthetic screw ', number: 0 },
                5: { name: 'Abutment/Ti', number: 0 },
                6: { name: 'Other ', number: 0 }
            },
            enclosedBoxObject: {
                1: { name: 'Impression/master model' },
                2: { name: 'Antagonist model/impression' },
                3: { name: 'Bite' },
                4: { name: 'Pre-op/temp model/impression' },
                5: {name:  'Optical scan'},
                6: { name: 'Implant parts' },
                7: { name: 'Other ' }
            },
            addingBookingInfo: {
                parent_id: null,
                patient_id: 0,
                sending_date: null,
                number_of_units: 0,
                type: '',
                notes: '',
                businessDaysBeforeReturnDate: [],
                eightBusinessDaysFromCurrentDate:  getNext8BusinessDays(),
                color: '',
                signature: '',
                license: '',
                implant: '',
                implantType: '',
                implantSize: '',
                enclosedBox: [],
                implantParts: {},
                image: [],
                bridges:[],
            },
            validationBooking: {
                patient_id: false,
                sending_date: false,
                implantParts: false,
                number_of_units: false,
                type: false,
                implant: false,
                enclosedBox: false,
            },
            checkedTeeth: [],
            editPatientInfo: undefined,
            dateNow: moment().toDate(),
            dateAfter10Days: moment().businessAdd(8).toDate(),
            addNewPatient: false,
            openBookingFormAfterAddNewPatient: false,
            addBookingShow: false,
            selectedDate: '',
            cancelModal: false,
            returnDate: '',
            dateOfReturnUTC:null,
            numberOfUnitsForPerDay: globals.NUMBER_OF_UNITS_MISC,
            numberOfUnitsForPerDayzirconia: globals.NUMBER_OF_UNITS_ZIRCONIA,
            moreThenAvailableUnitsModal: false,
            deletePatientModal: false,
            deletedPatiientId: 0,
            editPatientModal: false,
            editPatiientId: 0,
            run: false,
            printModal: false,
            floaterProps: {
                showCloseButton: false
            },
            hasErrorImages: false,
            isOpenLeaveModal: false,
            isOpenPickupModal: false,
            isOpenStartTour: false,
            isOpenCasesDropdown: false,
            createSubcaseModal: false,
            startOfCalendarView: formatDate( "start",locationState && locationState.defaultDate ? locationState.defaultDate : undefined),
            endOfCalendarView: formatDate( "end",locationState && locationState.defaultDate ? locationState.defaultDate : undefined),
            searchText: '',
            disableZirconiaType:false,
            dropRowId:null,
            disableMiscType:false,
            dataProcessing: false,
        };
        this.addNewPatient = this.addNewPatient.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleAddNewPatient = this.handleAddNewPatient.bind(this);
        this.fullNameFormatter = this.fullNameFormatter.bind(this);
        this.toggleCasesDropdown = this.toggleCasesDropdown.bind(this);
        this.toggleSubcaseFormModal = this.toggleSubcaseFormModal.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
        this.eventList = [];
    }

    onSearchChange(event) {
        this.setState({searchText: event.target.value});
        this.eventList = [];
    }

    componentDidMount() {
        document.title = "Home";
        this.props.getVacationDays(moment(new Date()).format('YYYY-MM-DD'));
        const { startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        this.props.getPatient({ startOfCalendarView, endOfCalendarView });
        this.props.getParentCases();
        this.setState({
            run: this.props.home.patientList.dentist ? (this.props.home.patientList.dentist.guide ? !this.props.home.patientList.dentist.subcase_onboarded : !this.props.home.patientList.dentist.guide) : false,
        })
        this.eventList = useDashboardEventList(this.props.home.patientList.events);

    }

    componentDidUpdate(prevProps,prevState) {
        if(prevProps.vacationDays !== this.props.vacationDays){
            if (this.props.vacationDays.length) {
                const lastLegalDay = getLastLegalDays(this.state.dateAfter10Days,this.props.vacationDays);
                this.setState({
                    dateAfter10Days: lastLegalDay,
                    addingBookingInfo: {
                        ...this.state.addingBookingInfo,
                        eightBusinessDaysFromCurrentDate: getNext8BusinessDays(this.props.vacationDays)
                    }
                })

            }
        }
    }

    toggleCasesDropdown() {
        this.setState({
            isOpenCasesDropdown: !this.state.isOpenCasesDropdown,
        })
    }

    toggleSubcaseFormModal(item) {
        if (item) {
            this.props.getCase(item.caseId)
        }
        this.setState({ isOpenSubcaseForm: false, addingBookingInfo: { ...this.state.addingBookingInfo, parent_id: item ? item.caseId : null } });
    }


    static defaultProps = {
        joyride: {}
    };

    handleJoyrideCallback(data) {
        const { joyride } = this.props;
        const { action, index, type, size } = data;

        if (action === ACTIONS.SKIP) {
            this.refs.joyride.helpers.reset();
            this.updateGuide();
        } else if (type === EVENTS.TOUR_END && size !== 1) {
            this.refs.joyride.helpers.reset();
            const slotInfo = {
                start: this.state.dateAfter10Days
            };
            if (moment(slotInfo.start).add(1, 'day').day() === 0 || moment(slotInfo.start).add(1, 'day').day() === 6) {
                slotInfo.start = moment(slotInfo.start).add(4, 'days');
                this.handleClickOnDay(slotInfo);
            } else {
                slotInfo.start = moment(slotInfo.start).add(1, 'days');
                this.handleClickOnDay(slotInfo);
            }
        } else if (type === EVENTS.TOUR_END && size === 1) {
            this.refs.joyride.helpers.reset();
            this.setState({ run: false });
            this.setState({showChangePasswordModal: true})
        }

        if (typeof joyride.callback === "function") {
            joyride.callback(data);
        }
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleClose() {
        if (!this.state.isOpenLeaveModal && this.state.addBookingShow && !this.state.printModal && (this.props.home.patientList.dentist.guide && !this.state.isOpenStartTour)) {
            this.setState({ isOpenLeaveModal: !this.state.isOpenLeaveModal });
        } else if (this.state.printModal) {
            this.setState({ isOpenPickupModal: true, printModal: false });
        } else {
            this.setState(prevState => ({
                addBookingShow: this.state.openBookingFormAfterAddNewPatient,
                printModal: false,
                showChangePasswordForm: false,
                showChangePasswordModal: false,
                openBookingFormAfterAddNewPatient: false,
                addNewPatient: false, cancelModal: false,
                moreThenAvailableUnitsModal: false,
                deletePatientModal: false,
                editPatientModal: false,
                validateNewPatient: { first_name: true, last_name: true },
                validationBooking: {
                    dentist_id: false,
                    patient_id: false,
                    sending_date: false,
                    implantParts: false,
                    number_of_units: false,
                    type: false,
                    implant: false,
                    enclosedBox: false
                },
                addingBookingInfo: {
                    businessDaysBeforeReturnDate: prevState.addingBookingInfo.businessDaysBeforeReturnDate,
                    eightBusinessDaysFromCurrentDate: prevState.addingBookingInfo.eightBusinessDaysFromCurrentDate,
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: [],
                    bridges: [],
                },
                checkedTeeth: [],
                isOpenLeaveModal: false,
                isOpenStartTour: false,
                createSubcaseModal: false
            }));
        }
        const { startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        this.props.getPatient({ startOfCalendarView, endOfCalendarView });
    }

    handleStay() {
        this.setState({ isOpenLeaveModal: false });
    }

    openTableRow = (cell) => {
        this.setState({dropRowId:cell})
    }

    handelChangeEdit(key, value) {
        this.setState(prevState => ({
            editPatientInfo: {
                ...prevState.editPatientInfo,
                [key]: value
            }
        }))
    }

    fullNameFormatter(row, cell) {
        return (
            <div className="patient-name">
                {cell.fullName}
            </div>
        )
    }

    actionsFormatter(row, cell) {
        const patientId = cell.id;
        return (
            <div className="user-actions">
                    <span
                        data-tip="Edit"
                        className="kr kr-edit"
                        onClick={(event) => this.editPatient(event, patientId)}
                    />
                <span
                    data-tip="Delete"
                    className="kr kr-delete"
                    onClick={(event) => this.deletePatient(event, patientId)}
                />
                <ReactTooltip place="top" type="light" effect="float"/>
            </div>
        )
    }

    makeBridge = (from,to) => {
        const bridges = this.state.addingBookingInfo.bridges;
        const checkedTeeth = this.state.checkedTeeth;
        if(from === to) {
            if(bridges.length){
                if(checkedTeeth.includes(from) && checkedTeeth.includes(to)){
                    const filteredBridge = bridges.filter((bridge)=> {
                        return bridge.from !== from
                    })
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:filteredBridge}
                    })
                } else {
                    bridges.push({from:from, to:to})
                    checkedTeeth.push(from);
                    this.setState({
                        checkedTeeth:checkedTeeth,
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            }else {
                checkedTeeth.push(to);
                bridges.push({from:from,to:to})
                this.setState({
                    checkedTeeth:checkedTeeth,
                    addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                })
            }

        } else {
            if(checkedTeeth.includes(from) && checkedTeeth.includes(to) && from !== 11 && from !== 41){
                let isBridged = false;
                const filteredBridges = bridges.filter(bridge => {
                    if (bridge.from === from && bridge.to === to) {
                        isBridged = true;
                        return false;
                    }
                    return bridge.from !== from && bridge.to !== to;
                })
                if(isBridged){
                    const filteredTeeth = checkedTeeth.filter((teeth)=>{
                        return teeth !== from && teeth !== to;
                    })
                    this.setState({
                        checkedTeeth:filteredTeeth,
                        addingBookingInfo:{
                            ...this.state.addingBookingInfo,
                            bridges: filteredBridges
                        }
                    })
                } else {
                    bridges.push({from:from,to:to});
                    this.setState({
                        addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                    })
                }
            } else {
                if(from === 11){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(21)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 21) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 21;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 21;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                addingBookingInfo:{
                                    ...this.state.addingBookingInfo,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:21});
                            checkedTeeth.push(from,21);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:21});
                        checkedTeeth.push(from,21);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                        })
                    }
                } else if(from === 41){
                    let isBridged = false;
                    if(checkedTeeth.includes(from) && checkedTeeth.includes(31)){
                        const filteredBridges = bridges.filter(bridge => {
                            if (bridge.from === from && bridge.to === 31) {
                                isBridged = true;
                                return false;
                            }
                            return bridge.from !== from && bridge.to !== 31;
                        })
                        if(isBridged){
                            const filteredTeeth = checkedTeeth.filter((teeth)=>{
                                return teeth !== from && teeth !== 31;
                            })
                            this.setState({
                                checkedTeeth:filteredTeeth,
                                addingBookingInfo:{
                                    ...this.state.addingBookingInfo,
                                    bridges: filteredBridges
                                }
                            })
                        } else {
                            bridges.push({from:from, to:31});
                            checkedTeeth.push(from,31);
                            this.setState({
                                checkedTeeth:checkedTeeth,
                                addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                            })
                        }
                    }else {
                        bridges.push({from:from, to:31});
                        checkedTeeth.push(from,31);
                        this.setState({
                            checkedTeeth:checkedTeeth,
                            addingBookingInfo:{...this.state.addingBookingInfo,bridges:bridges}
                        })
                    }

                } else {
                    bridges.push({from: from, to: to});
                    checkedTeeth.push(from, to);
                    this.setState({
                        checkedTeeth: checkedTeeth,
                        addingBookingInfo: {...this.state.addingBookingInfo, bridges: bridges}
                    })
                }
            }
        }
    }

    editPatient(event, patientId) {
        if (this.state.editPatientModal) {
            const first_name = !!(this.state.editPatientInfo.first_name);
            const last_name = !!(this.state.editPatientInfo.last_name);
            if (!first_name || !last_name) {
                this.setState({
                    validateNewPatient: {
                        first_name: first_name,
                        last_name: last_name,
                    }
                })
            } else {
                this.props.editPatient(prevState => ({
                    ...prevState.editPatientInfo,
                    startDate: prevState.startOfCalendarView,
                    endDate: prevState.endOfCalendarView,
                }));
            }
        } else {
            const patient = this.getPatientById(patientId);
            this.setState({
                editPatientModal: true,
                editPatiientId: patientId,
                editPatientInfo: patient,
            });
        }
        event.stopPropagation();
    }

    deletePatient(event, patientId) {
        if (this.state.deletePatientModal) {
            const {startOfCalendarView: startDate ,endOfCalendarView: endDate } = this.props.calendarRange
            this.props.deletePatient(patientId, { startDate, endDate });
        } else {
            this.setState({
                deletePatientModal: true,
                deletedPatiientId: patientId,
            });
        }
        event.stopPropagation();
    }

    getPatientById(patientId) {
        let patient = undefined;
        this.patientList.map((item) => {
            if (item.id === patientId) {
                return patient = item;
            } else {
                return false;
            }
        });
        return patient;
    }

    updateGuide() {
        this.setState({ isOpenStartTour: false });
        this.props.updateGuide();
        // avoid state conflicts
        setTimeout(() => {
            this.setState({showChangePasswordModal: true})
        },1000)
    }

    linkToCasesPage(row) {
        this.props.getPatient({ patientId: row.id });
        this.props.history.push('/case-summary/' + row.id);
    }

    addNewPatient(guide) {
        if (!guide) {
            return false;
        }
        if (this.state.addBookingShow) {
            this.setState({ addNewPatient: true, openBookingFormAfterAddNewPatient: true, addBookingShow: false })
        } else {
            this.setState({ addNewPatient: true })
        }
    }

    handleAddNewPatient() {
        const { newPatient } = this.state;
        const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        const first_name = !!newPatient.first_name;
        const last_name = !!newPatient.last_name;
        newPatient.startDate = startOfCalendarView;
        newPatient.endDate = endOfCalendarView;
        if (!first_name || !last_name) {
            this.setState({ validateNewPatient: { first_name: first_name, last_name: last_name } })
        } else {
            this.props.addPatient({ ...newPatient, startDate: startOfCalendarView, endDate: endOfCalendarView });
        }
    }

    handelChange(key, value) {
        this.setState(prevState => ({
            newPatient: {
                ...prevState.newPatient,
                [key]: value
            }
        }))
    }

    handleChangeSendingDate(sendingDate) {
        this.setState(prevState => ({
            addingBookingInfo: {
                ...prevState.addingBookingInfo,
                sending_date: sendingDate
            },
            validationBooking: {
                ...prevState.validationBooking,
                sending_date:  !sendingDate,
            }
        }));
    }

    handleClickOnDay(slotInfo) {
        const day = moment(slotInfo.end).format("YYYY-MM-DD");
        const dayUnits = this.props.home.patientList.numberOfUnits[day];
        const disableMiscType = dayUnits && dayUnits.units === 0;
        const disableZirconiaType = dayUnits && dayUnits.units_for_zirconia === 0;

        this.setState({disableMiscType,disableZirconiaType})

        const dateNow = moment();
        let addBookingShow = true;
        let notValidDate = false;
        const startDate = moment(slotInfo.start);
        const unitsKey = useDashboardUnitKey(slotInfo.start, this.props.home.patientList.numberOfUnits);
        const dayKey = moment(slotInfo.start).format('YYYY-MM-DD');
        var numberOfUnits=globals.NUMBER_OF_UNITS_MISC,
            numberOfUnitsZirconia=globals.NUMBER_OF_UNITS_ZIRCONIA;
        let isVacationDay = false;
        this.props.vacationDays && this.props.vacationDays.forEach((item)=>{
            if(resetDateTime(new Date(item.start)) <= new Date(slotInfo.start).getTime() && new Date(slotInfo.start).getTime() <= resetDateTime(new Date(item.end))){
                isVacationDay = true;
            }
        })
        if (this.state.run && this.props.home.patientList.dentist.subcase_onboarded || this.state.isOpenStartTour) {
            this.setState({
                addBookingShow: true,
                selectedDateKey: moment(startDate).format('YYYY-MM-DD'),
                selectedDate: moment(startDate).format('YYYY-MM-DD'),
                returnDate: moment(startDate).format('L'),
                dateOfReturnUTC: startDate,
                numberOfUnitsForPerDay: numberOfUnits
            })
            return;
        }
        if (unitsKey !== undefined) {
            numberOfUnits = this.props.home.patientList.numberOfUnits[unitsKey].units;
            numberOfUnitsZirconia=this.props.home.patientList.numberOfUnits[unitsKey].units_for_zirconia;
            // this.setState({
            //     customUnitsMisc: this.props.home.patientList.specialDays[unitsKey].units,
            //     customUnitsZyrc: this.props.home.patientList.specialDays[unitsKey].units_for_zirconia
            // })
        } else if (this.props.home.patientList.specialDays !== undefined &&
            this.props.home.patientList.specialDays[dayKey] !== undefined) {
            numberOfUnits = this.props.home.patientList.specialDays[dayKey].units;
            numberOfUnitsZirconia = this.props.home.patientList.specialDays[dayKey].units_for_zirconia;
        }
        const mountDiff = moment(startDate).diff(moment(dateNow), 'months', true);
        const statusOfDay = (unitsKey !== undefined)
            ?
            this.props.home.patientList.numberOfUnits[unitsKey].status
            :
            'scheduled';
        if (this.props.home.patientList.isInactiveOrPending) {
            Notice.addNotification('Please, wait until admin activates your account.', 'error');
            addBookingShow = false;
            notValidDate = true;
        } else if (startDate.day() === 0 || startDate.day() === 6 || isVacationDay) {
            Notice.addNotification('Weekends and vacation days are not available for booking.', 'error');
            addBookingShow = false;
            notValidDate = true;
        } else if (mountDiff >= 12 && addBookingShow) {
            Notice.addNotification('You can make a booking only for upcoming 12 months. Please select a date within this period.', 'error');
            addBookingShow = false;
            notValidDate = true;
        } else if (startDate <= this.state.dateNow && addBookingShow) {
            Notice.addNotification('You are trying to select a passed date. Passed dates are not available for booking. Please select an upcoming date.', 'error');
            addBookingShow = false;
            notValidDate = true;
        } else if (numberOfUnitsZirconia <= 0 && numberOfUnits <= 0) {
            Notice.addNotification('No units available for this date. Please contact with administrator.', 'error');
            addBookingShow = false;
            notValidDate = true;
        }

        if (startDate >= this.state.dateNow && this.state.addingBookingInfo.eightBusinessDaysFromCurrentDate.includes(moment(startDate).format("YYYY-MM-DD")) && addBookingShow) {
            Notice.addNotification('8 days from the given date are unavailable for booking. Please select another date.', 'error');
            addBookingShow = false;
            notValidDate = true;
            return;
        }
        if (this.state.addBookingShow) {
            if (!notValidDate) {
                this.setState({ addBookingShow: addBookingShow, selectedDateKey: moment(startDate).format('YYYY-MM-DD'), selectedDate: moment(startDate).format('YYYY-MM-DD'), returnDate: moment(startDate).format('L'), numberOfUnitsForPerDay: numberOfUnits, numberOfUnitsForPerDayZirconia: numberOfUnitsZirconia, dateOfReturnUTC: startDate,
                })
            }
        }
        if (notValidDate && this.state.run && this.props.home.patientList.dentist.subcase_onboarded || this.state.isOpenStartTour) {
            this.setState({
                addBookingShow: true,
                selectedDateKey: moment(startDate).format('YYYY-MM-DD'),
                selectedDate: moment(startDate).format('MMM DD,YYYY'),
                returnDate: moment(startDate).format('L'),
                numberOfUnitsForPerDay: numberOfUnits,
                numberOfUnitsForPerDayZirconia: numberOfUnitsZirconia,
            })
        } else {
            this.setState({
                addBookingShow: addBookingShow,
                selectedDateKey: moment(startDate).format('YYYY-MM-DD'),
                selectedDate: moment(startDate).format('MMM DD,YYYY'),
                returnDate: moment(startDate).format('L'),
                dateOfReturnUTC: startDate,
                numberOfUnitsForPerDay: numberOfUnits,
                numberOfUnitsForPerDayZirconia: numberOfUnitsZirconia,
            })
        }
        if (addBookingShow) {
            this.setState({
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    businessDaysBeforeReturnDate: findBusinessDays(this.props.vacationDays,moment(startDate).format('L'),8)
                }
            });
        }
    }

    setHeaderColor(calendarDate, dateAfter10Days, countOfUnitsMisc, countOfUnitsZyrc, statusOfDay) {
        let className = 'success';
        if (statusOfDay === 'pending') {
            className = 'blockedItem';
        } else if (calendarDate <= dateAfter10Days || countOfUnitsMisc <= 0 && countOfUnitsZyrc <= 0) {
            className = 'danger';
        } else if (moment(calendarDate).day() === globals.SUNDAY_INDEX || moment(calendarDate).day() === globals.SATURDAY_INDEX) {
            className = 'danger';
        } else if (countOfUnitsMisc <= globals.warningCountOfMisc || countOfUnitsZyrc <= globals.warningCountOfZirc) {
            className = 'warning';
        }
        return className
    }

    cancelBooking() {
        this.setState({ cancelModal: true });
    }

    handleCanceling() {
        this.setState({
            createSubcaseModal: false,
            isOpenStartTour: false,
            addBookingShow: false,
            cancelModal: false,
            moreThenAvailableUnitsModal: false,
            selectedDate: '',
            selectedDateKey: '',
        });
    }

    handleChangePatient(selectedOption) {
        this.setState(prevState => ({
            addingBookingInfo: {
                ...prevState.addingBookingInfo,
                patient_id: selectedOption ? selectedOption.value : 0
            },
            validationBooking: {
                ...prevState.validationBooking,
                patient_id:  selectedOption && !selectedOption.value,
            }
        }));
    }

    handleChangeBookingInfo(key, value, find) {
        this.setState(prevState => ({
            validationBooking: {
                ...prevState.validationBooking,
                [key]:  !value,
            }
        }))

        if (key === 'enclosedBox') {
            const enclosedBox = this.state.addingBookingInfo[key];
            const find = enclosedBox.find(item => { return item === value });
            const updateData = (find > 0) ? enclosedBox.filter(e => e !== value) : [...this.state.addingBookingInfo[key], value];;
            this.setState({
                addingBookingInfo: { ...this.state.addingBookingInfo, [key]: updateData }
            })
        } else if (key === 'implantParts') {
            let updateData, implantParts = this.state.addingBookingInfo[key];
            if (implantParts[value] !== undefined && !find) {
                delete implantParts[value]
                updateData = implantParts;
            } else {
                updateData = { ...this.state.addingBookingInfo[key], [(find) ? find : value]: (find) ? value : 0 }
            }
            this.setState({
                addingBookingInfo: { ...this.state.addingBookingInfo, [key]: updateData }
            })
        } else if (key === 'image') {
            const images = this.state.addingBookingInfo.image;
            if (value.hasError) {
                this.setState({ hasErrorImages: true });
            } else {
                this.setState(prevState => ({
                    addingBookingInfo: {
                        ...prevState.addingBookingInfo,
                        image: [...images, ...value.currentImage],
                    },
                    hasErrorImages: false
                }))
            }
        } else {
            this.setState({
                addingBookingInfo: {
                    ...this.state.addingBookingInfo,
                    [key]: value
                }
            })
        }
    }

    clickOutside(ref) {
        ref.cancelFocusInput();
        ref.setOpen(false);
    }

    async handleSaveBooking() {
        const bookingInfo = this.state.addingBookingInfo;
        const patient_id = bookingInfo.patient_id <= 0;
        const number_of_units = bookingInfo.number_of_units <= 0;
        const type = !(bookingInfo.type && (bookingInfo.type.value === 'prototype' || bookingInfo.type.value === 'zirconia' || bookingInfo.type.value === 'other' || bookingInfo.type.value === 'temp' || bookingInfo.type.value === 'ceramic'));
        const implant = !(bookingInfo.implant === '1' || bookingInfo.implant === '0');
        const sending_date = !bookingInfo.sending_date;
        const enclosedBox = !bookingInfo.enclosedBox.length;
        const implantPartValues = Object.values(bookingInfo.implantParts);
        const implantParts = implantPartValues.length > 0 && !implantPartValues.every(Boolean);
        if (patient_id || number_of_units || type || implant || sending_date || enclosedBox || implantParts) {
            this.setState({
                validationBooking: {
                    patient_id: patient_id,
                    number_of_units: number_of_units,
                    implantParts,
                    type: type,
                    implant: implant,
                    sending_date: sending_date,
                    enclosedBox: enclosedBox
                }
            });
        } else {
            let exceeds;
            if(bookingInfo.type.value != 'zirconia' && bookingInfo.type.value != 'ceramic') {
                exceeds = bookingInfo.number_of_units > this.state.numberOfUnitsForPerDay;
            } else {
                exceeds = bookingInfo.number_of_units > this.state.numberOfUnitsForPerDayZirconia;
            }
            if (exceeds && !this.state.moreThenAvailableUnitsModal) {
                this.setState({ moreThenAvailableUnitsModal: true, openBookingFormAfterAddNewPatient: true, addBookingShow: false });

            } else {
                this.setState({ dataProcessing: true })
                await processImageUpdate(this.state,this.bridgesRef.current)
                const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
                const sendingData = {
                    patient_id: bookingInfo.patient_id,
                    sending_date: moment(bookingInfo.sending_date).format('YYYY-MM-DD'),
                    number_of_units: bookingInfo.number_of_units,
                    type: bookingInfo.type.value,
                    notes: bookingInfo.notes,
                    date_of_submission: moment(this.state.dateNow).format('YYYY-MM-DD'),
                    date_of_return: moment(this.state.returnDate).format('YYYY-MM-DD'),
                    status: exceeds ? 'pending' : 'scheduled',
                    isAdmin: false,
                    color: bookingInfo.color,
                    signature: bookingInfo.signature,
                    license: bookingInfo.license || this.props.hasLicense,
                    implant: bookingInfo.implant,
                    implantType: bookingInfo.implantType,
                    implantSize: bookingInfo.implantSize,
                    enclosedBox: bookingInfo.enclosedBox,
                    implantParts: bookingInfo.implantParts,
                    image: bookingInfo.image,
                    startDate: startOfCalendarView,
                    endDate: endOfCalendarView,
                    bridges:bookingInfo.bridges,
                };
                this.setState({
                    openBookingFormAfterAddNewPatient: false
                })
                this.props.addBooking(sendingData);
            }
        }
    }

    get patientList() {
        const searchText = this.state.searchText.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return this.props.home.patientList.patients ? this.props.home.patientList.patients.filter(patient => {
            return patient.id.toString().indexOf(searchText) === 0 || patient.fullName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(searchText) === 0 ||  patient.fullName.split(' ').some(item => item.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(searchText) === 0)
        }) : [];
    }

    get parentCasesList() {
        return this.props.home.parentCases;
    }

    get dentistName() {
        return this.props.home.patientList.dentistName || '';
    }

    hendleClickOnEvent(event) {
        const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
        this.props.props.history.push({
            pathname: '/case-details/' + event.caseId,
            state: {
                page: '/account',
                pageName: 'Home',
                startOfCalendarView,
                endOfCalendarView,
            }
        });
    }

    handlePageChange = (page) => {
        scrollTo(0,'smooth');
        this.setState({
            tableOption: {
                ...this.state,
                page
            }
        }, () => {
            const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
            this.props.getPatient({ page, startOfCalendarView, endOfCalendarView });
        });
    }
    componentWillReceiveProps(nextProps, nextState) {
        if (!this.props.home.patientList.dentist && nextProps.home.patientList.dentist) {
            this.setState({
                run: (nextProps.home.patientList.dentist.guide ? !nextProps.home.patientList.dentist.subcase_onboarded : !nextProps.home.patientList.dentist.guide),
            })
        }
        if (!this.props.home.editGuide && nextProps.home.editGuide) {
            this.setState({ run: false, isOpenStartTour: false });
            const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
            this.props.getPatient({ startOfCalendarView, endOfCalendarView });
        }
        if (this.state.selectedDateKey !== undefined) {
            const selectDate = this.state.selectedDateKey;
            if (nextProps.home.patientList.numberOfUnits[selectDate] !== undefined) this.setState({ numberOfUnitsForPerDay: nextProps.home.patientList.numberOfUnits[selectDate].units });
        }
        if (nextProps.home.addBookingRequest === true) {
            Notice.addNotification(ADD_CASE_SUCCESS_MESSAGE, 'success');
            const {startOfCalendarView, endOfCalendarView } = this.props.calendarRange;
            this.props.getPatient({ startOfCalendarView, endOfCalendarView });
            this.props.getCase(nextProps.home.addedData);
            this.props.startImageUploading({caseId: nextProps.home.addedData, isAdmin: false, getCase: false});
            if (this.state.moreThenAvailableUnitsModal) {
                this.handleClose();
            }
        }
        if (this.props.imageUpload.uploadingComplete && !this.props.imageUpload.uploadingImages && !this.props.imageUpload.hasErrors && this.state.addBookingShow) {
            this.setState(prevState => ({
                addBookingShow: false,
                moreThenAvailableUnitsModal: false,
                printModal: true,
                dataProcessing: false,
                modalHeaderText: 'Print Booking',
                modalBodyText: 'Would you like to print the case?',
                addingBookingInfo: {
                    eightBusinessDaysFromCurrentDate: prevState.addingBookingInfo.eightBusinessDaysFromCurrentDate,
                    parent_id: null,
                    patient_id: 0,
                    sending_date: null,
                    number_of_units: 0,
                    type: '',
                    notes: '',
                    color: '',
                    signature: '',
                    license: '',
                    implant: '',
                    implantType: '',
                    implantSize: '',
                    enclosedBox: [],
                    implantParts: {},
                    image: [],
                    bridges:[],
                },
                checkedTeeth:[],
                isOpenSubcaseForm: false,
                validationBooking: { patient_id: false, number_of_units: false, type: false, implant: false, sending_date: false, enclosedBox: false, implantParts: false}
            }));
            if (Object.keys(nextProps.imageUpload.achievedUploads).length) {
                Notice.addNotification('Images successfully uploaded.', 'success');
            }
        } else if (nextProps.home.addBookingRequest === false) {
            Notice.addNotification('Your session is expired.', 'error');
            this.setState({ moreThenAvailableUnitsModal: false, deletePatientModal: false, validationBooking: { patient_id: false, number_of_units: false, type: false, sending_date: false, enclosedBox: false,implantParts: false }, addNewPatient: false, addBookingShow: this.state.openBookingFormAfterAddNewPatient, openBookingFormAfterAddNewPatient: false });
        } else if (nextProps.home.deletePatient) {
            this.setState({ deletePatientModal: false })
        } else if (nextProps.home.editPatient === false) {
            //Notice.addNotification('Your session is expired.', 'error');
            this.setState({ editPatientModal: false })
        } else if (nextProps.home.editPatient) {
            Notice.addNotification('Patient is successfully edited.', 'success');
            this.setState({ editPatientModal: false })
        } else if (nextProps.home.added) {
            Notice.addNotification('Patient is successfully added.', 'success');
            this.setState({ addNewPatient: false, addBookingShow: this.state.openBookingFormAfterAddNewPatient, newPatient: { first_name: '', last_name: '', notes: '' }, validateNewPatient: { first_name: true, last_name: true }, addingBookingInfo: { ...this.state.addingBookingInfo, patient_id: nextProps.home.patientList.newPatient.id } })
        } else if (nextProps.home.pickupScheduled && !this.props.home.pickupScheduled) {
            Notice.addNotification(SCHEDULE_PICKUP_CASE_SUCCESS_MESSAGE, 'success');
            this.setState({ isOpenPickupModal: false });
        }
        if (nextProps.home.gotCaseDetails && !this.props.home.gotCaseDetails && this.state.addingBookingInfo.parent_id && !this.state.printModal) {
            this.setState({ isOpenSubcaseForm: true, createSubcaseModal: false });
        }
        if(nextProps.home.patientList.events !== this.props.home.patientList.events) {
            this.eventList = useDashboardEventList(nextProps.home.patientList.events);
        }
        if(this.props.home.pickupScheduled){
            Notice.addNotification('Pickup Scheduled', 'success');
        }
    }

    renderEventHeader(props) {
        const unitsKey = useDashboardUnitKey(props.date, this.props.home.patientList.numberOfUnits);
        const dayKey = moment(props.date).format('YYYY-MM-DD');

        let misc = globals.NUMBER_OF_UNITS_MISC,
            zirconia = globals.NUMBER_OF_UNITS_ZIRCONIA;

        if (unitsKey !== undefined) {
            misc = this.props.home.patientList.numberOfUnits[unitsKey].units;
            zirconia = this.props.home.patientList.numberOfUnits[unitsKey].units_for_zirconia;
        } else if (this.props.home.patientList.specialDays !== undefined && this.props.home.patientList.specialDays[dayKey] !== undefined) {
            misc = this.props.home.patientList.specialDays[dayKey].units;
            zirconia = this.props.home.patientList.specialDays[dayKey].units_for_zirconia || 0;
        }
        const statusOfDay = (unitsKey !== undefined) ? this.props.home.patientList.numberOfUnits[unitsKey].status : 'scheduled';
        const className = useDashboardCaseBlockHeaderColor(
            props.date, this.state.dateAfter10Days, misc, zirconia, statusOfDay,this.props.vacationDays, this.state.addingBookingInfo.eightBusinessDaysFromCurrentDate
        );
        return (
            <div className={"custom-day-header-" + className} >
                <small
                    className="custom-day-header">
                    {(className === 'danger') ?
                        'Not Available'
                        :
                        `M:${misc ? misc : ' UN'}  Z/C:${zirconia ? zirconia : ' UN'}`}
                </small>
                {props.label}
            </div>
        )
    }

    removeImage(name) {
        this.setState({
            addingBookingInfo: {
                ...this.state.addingBookingInfo,
                image: this.state.addingBookingInfo.image.filter(image => image.filename !== name)
            }
        });
    }

    schedulePickup() {
        this.props.addPickup(this.props.home.caseList.caseDetails.id, true)
    }

    handleClosePickupModal() {
        this.setState({ isOpenPickupModal: false });
        Notice.addNotification('You can schedule a pickup from Cases menu when the case is ready', 'success');
    }

    onDateRangeChange = (date, view, action) => {
        clearInterval(this.interval);
        const startOfCalendarView = moment(dates.firstVisibleDay(date)).format('YYYY-MM-DD');
        const endOfCalendarView = moment(dates.lastVisibleDay(date)).format('YYYY-MM-DD');
        this.props.onDateChange({
            startOfCalendarView,
            endOfCalendarView,
            defaultDate: date,
        })
        this.props.getPatient({ startOfCalendarView, endOfCalendarView });
    };

    childColumnFormatter = (cell, row) => {


        return row.parentId ? <div className="subcase_image"><a
            data-tip={`This is a subcase of case N${row.parentId}`}
            data-for="child"
            href={`/case-details/${row.parentId}`}>
            <img className="ml-0 mr-1" src={SubIconBlack} color="#000" alt={row.parentId}/>
        </a>
            <ReactTooltip id="child" place="right" type="light" effect="float" />
        </div> : null;
    }




    render() {
        let steps = [];
        if (this.props.home.patientList && this.props.home.patientList.dentist
            && this.props.home.patientList.dentist.guide && !this.state.isOpenStartTour) {
            steps = [
                {
                    target: '.add-subcase',
                    content: <div>NEW FUNCTIONALITY!
                        <br /><br />
                        We’ve made it easier to track the progress
                        of each case for the same patient!
                        When booking a next appointment date for the next stage
                        of an ongoing case, please click on “Create Sub-case”
                        button and select the associated Case ID.
                        You can then proceed your booking as usual.
                        You can then track all your cases for
                        a certain patient from “Cases” menu.
                    </div>,
                    placement: 'top',
                    disableBeacon: true
                }
            ]
        } else {
            steps = [
                {
                    target: '.bigcalendar',
                    content: 'This is your monthly calendar. Dates available for booking are highlighted in green/orange. Please see the legend in the bottom for details.',
                    placement: 'bottom',
                    disableBeacon: true
                },
                {
                    target: '.rbc-date-cell',
                    content: 'This is the number of units available to book for each day. Select the date when you need the case to be completed.',
                    placement: 'left'
                },
                {
                    target: '.new_patient_btn',
                    content: 'Your patients can be added from here.',
                    placement: 'auto'
                },
                {
                    target: '.case_summary_tab',
                    content: 'All your cases can be viewed here.',
                    placement: 'auto'
                },
                {
                    target: '.subcase_tour',
                    content: 'When you\'re booking a next delivery date for the next stage for an ongoing case, you may use this button to do so. The subcases will be organized within their corresponding cases for easier follow-ups.\n' +
                        'For example, if you had previously booked a case as "Prototype" and you are now booking a date for "Zirconia" under the same patient file, you would use this button to keep the patient\'s case progress organized.',
                    placement: 'auto'
                },
                {
                    target: '.notification-button',
                    content: 'This is your notification area where you will be notified when cases are updated.',
                    placement: 'left'
                }
            ]
        }

        const header = 'Home ';
        const desc = 'My patients & bookings';
        const joyrideProps = {
            run: this.state.run || this.state.isOpenStartTour,
            steps,
            ...this.props.joyride
        };
        return (
            <div className="view">
                <Joyride
                    ref="joyride"
                    scrollToFirstStep
                    disableCloseOnEsc
                    disableOverlayClose
                    disableScrolling
                    showProgress
                    showSkipButton
                    autoStart={true}
                    {...joyrideProps}
                    continuous={steps.length > 1}
                    callback={(data) => this.handleJoyrideCallback(data)}
                    styles={{
                        options: {
                            primaryColor: "#54D043"
                        }
                    }}
                />
                <ViewHeader
                    header={header}
                    desc={desc}
                    openTour={() => this.setState({ isOpenStartTour: true })}
                    openSubCaseModal={() => this.setState({ createSubcaseModal: true }, () => this.props.getParentCases())}
                    disabled={!this.parentCasesList.length}
                    isTour={true}
                />
                <div className="view-content dentist__dashboard dashboard-calendar">
                    <div>
                        <div className="user">
                            <div className="user__block">
                                <div className="user__list">
                                    {
                                        (this.props.home.loadingBookings === true) ?
                                            <Spinner />
                                            :
                                            <PatientsTable
                                                locationState={this.locationState}
                                            />
                                    }
                                </div>
                                <div className="user__cases">
                                    {
                                        (this.props.home.loadingBookings === true || this.props.vacationDaysLoading) ?
                                            <h2 className="text-center marginTopLoading"><IconSpinner className="spinner" /> Loading...</h2>
                                            :
                                            <Fragment>
                                                <div className="tabs">
                                                    <div className={`tabs__item ${this.props.tabName === 'patients' ? 'active_tab' : ''}`} onClick={()=>this.props.changeTab('patients')}>Calendar</div>
                                                    <div className={`tabs__item case_summary_tab ${this.props.tabName === 'case_summary' ? 'active_tab' : ''}`} onClick={()=>this.props.changeTab('case_summary')}>Case Summary</div>
                                                </div>
                                                <div className="dashboard-block">
                                                    <div className="dashboard-block__container">
                                                        <BigCalendar
                                                            className="bigcalendar"
                                                            events={this.eventList}
                                                            onNavigate={this.onDateRangeChange}
                                                            startAccessor='startDate'
                                                            endAccessor="endDate"
                                                            onSelectSlot={(slotInfo) => {
                                                                if (slotInfo && slotInfo.slots.length) {
                                                                    this.handleClickOnDay(slotInfo)
                                                                }
                                                            }}
                                                            onSelectEvent={event => this.hendleClickOnEvent(event)}
                                                            selectable={(this.props.home.patientList.dentist) ? this.props.home.patientList.dentist.guide : false}
                                                            longPressThreshold={250}
                                                            views={{ month: true, week: true, day: true }}
                                                            eventPropGetter={useDashboardEventStyle}
                                                            defaultView='month'
                                                            defaultDate={this.props.calendarRange.defaultDate}
                                                            timeslots={8}
                                                            popup={true}
                                                            components={{
                                                                month: {
                                                                    dateHeader: (props) => this.renderEventHeader(props),
                                                                    event: (props) => {
                                                                        return (
                                                                            <div className="rbc-row-segment">
                                                                                <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                                                                    <div className="type-block">
                                                                                        <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                                                        <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                                                        <ReactTooltip html={true} place="top" type="light" effect="float" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                },
                                                                week: {
                                                                    header: (props) => this.renderEventHeader(props),
                                                                    event: (props) => {
                                                                        return (
                                                                            <div className="rbc-row-segment">
                                                                                <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                                                                    <div className="type-block">
                                                                                        <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                                                        <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                                                        <ReactTooltip place="top" type="light" effect="float" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                },
                                                                day: {
                                                                    header: (props) => this.renderEventHeader(props),
                                                                    event: (props) => {
                                                                        return (
                                                                            <div className="rbc-row-segment day">
                                                                                <div className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                                                                    <div className="type-block">
                                                                                        <div className="rbc-event-content text-left" title={props.event.title}>{props.event.title}</div>
                                                                                        <div className="rbc-event-number" style={{ textAlign: 'right' }} title="Number of units">{props.event.numberOfUnits}</div>
                                                                                        <ReactTooltip place="top" type="light" effect="float" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="info-block">
                                                        <span className="kr kr-info" />
                                                        <span className="info-text">Tap & hold on the cell to book a new case.</span>
                                                    </div>
                                                    <div className="colored-block">
                                                        <div className="colored-block__item pink">
                                                            <span>Pink</span>
                                                            <p>
                                                                Pink color means vacation days marked on calendar.
                                                            </p>
                                                        </div>
                                                        <div className="colored-block__item green">
                                                            <span>Green</span>
                                                            <p>
                                                                Green colour means there is a sufficient number of units available (the number is
                                                                displayed on the calendar). You can book more units than available. However, your
                                                                booking will be sent for a confirmation from the lab.
                                                            </p>
                                                        </div>
                                                        <div className="colored-block__item orange">
                                                            <span>Orange</span>
                                                            <p>
                                                                Orange colour means a small number of units is left available. (the number is
                                                                displayed
                                                                on the calendar). You can still book more units than available. However, your
                                                                booking
                                                                will be sent for a confirmation from the lab.
                                                            </p>
                                                        </div>
                                                        <div className="colored-block__item red">
                                                            <span>Red</span>
                                                            <p>
                                                                Red colour means no units are available for booking.
                                                            </p>
                                                        </div>
                                                        <div className="colored-block__item black">
                                                            <span>Black</span>
                                                            <p>
                                                                Black colour means all the units are booked, however need to be confirmed by
                                                                administrator. Note: if booking is rejected than units will again become available.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Fragment>
                                    }
                                </div>
                                {
                                    <ModalComponent
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle="Change Password"
                                        modalBody="You’ve logged in with a temporary password. Please create a new password now to continue using your account.?"
                                        show={this.state.showChangePasswordModal && this.props.createdByAdmin}
                                        handleClose={() => this.handleClose()}
                                        buttonText="Change"
                                        buttonFunction={() => {
                                            this.handleClose();
                                            this.setState({showChangePasswordForm: true, showChangePasswordModal: false})
                                        }}
                                    />
                                }
                                {
                                    this.state.showChangePasswordForm ? (
                                        <EditPasswordForm
                                            isModalOpened={true}
                                            closeModal={() => {
                                                this.handleClose()
                                            }}
                                        />
                                    ) : null
                                }
                                {
                                    this.state.addBookingShow &&
                                    <ModalComponent
                                        dialogClassName="book-case__dialog user__booking"
                                        handleUpdateGuide={() => this.updateGuide()}
                                        guideRun={this.props.home.patientList.dentist.guide && !this.state.isOpenStartTour}
                                        modalHeaderStyle="modalHeaderDefault"
                                        headerTitle="Book Case"
                                        isAdmin={false}
                                        modalBody={
                                            <AddBookingForm
                                                hasLicense={this.props.hasLicense}
                                                loading={this.props.home.addingDataLoading}
                                                disableMiscType={this.state.disableMiscType}
                                                businessDaysBeforeReturnDate={this.state.addingBookingInfo.businessDaysBeforeReturnDate}
                                                disableZirconiaType={this.state.disableZirconiaType}
                                                guideRun={this.props.home.patientList.dentist.guide && !this.state.isOpenStartTour}
                                                onClickOutside={(ref) => this.clickOutside(ref)}
                                                cancelBooking={() => this.cancelBooking()}
                                                handleChange={(key, value, find = null) => this.handleChangeBookingInfo(key, value, find)}
                                                handleChangePatient={(selectedOption) => this.handleChangePatient(selectedOption)}
                                                handleChangeSendingDate={(sendingDate) => this.handleChangeSendingDate(sendingDate)}
                                                selectedDate={this.state.selectedDate}
                                                selectedDateKey={this.state.selectedDateKey}
                                                dateOfSubmittion={moment(this.state.dateNow).format('YYYY-MM-DD')}
                                                dentist={this.dentistName}
                                                patientList={this.patientList}
                                                handleSaveBooking={() => this.handleSaveBooking()}
                                                validation={this.state.validationBooking}
                                                addNewPatient={(guide) => this.addNewPatient(guide)}
                                                numberOfUnits={this.state.addingBookingInfo.number_of_units}
                                                numberOfUnitsForPerDay={this.state.numberOfUnitsForPerDay}
                                                implantsPart={this.state.addingBookingInfo.implantParts}
                                                enclosedBox={this.state.addingBookingInfo.enclosedBox}
                                                implantsPartObject={this.state.implantsPartObject}
                                                enclosedBoxObject={this.state.enclosedBoxObject}
                                                data={this.state.addingBookingInfo}
                                                hasErrorImages={this.state.hasErrorImages}
                                                isAdmin={false}
                                                dentistList={[]}
                                                removeImage={(fileName) => this.removeImage(fileName)}
                                                list={this.props.home.patientList}
                                                listNumberOfUnits={this.props.home.patientList.numberOfUnits}
                                                specialDays={this.props.home.patientList.specialDays}
                                                date_of_return={this.state.returnDate}
                                                dateOfReturnUTC={this.state.dateOfReturnUTC}
                                                minSendingDate={true}
                                                vacationDays={this.props.vacationDays}
                                                bridges={this.state.addingBookingInfo.bridges}
                                                checkedTeeth={this.state.checkedTeeth}
                                                makeBridge={(from,to)=>this.makeBridge(from,to)}
                                                bridgesRef={this.bridgesRef}
                                            />
                                        }
                                        show={this.state.addBookingShow}
                                        handleClose={() => this.handleClose()}
                                        buttonText="Save"
                                        buttonFunction={() => this.handleSaveBooking()}
                                        addBookingForm={true}
                                        saveDisabled={this.props.home.addingDataLoading || this.state.dataProcessing}
                                    />
                                }
                            </div>
                            {
                                this.state.cancelModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Cancel Booking"
                                    modalBody="Data you have inserted will be lost. Are you sure you want to leave?"
                                    show={this.state.cancelModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Cancel"
                                    buttonFunction={() => this.handleCanceling()}
                                />
                            }
                            {
                                this.state.addNewPatient &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Add New Patient"
                                    modalBody={<CustomModalBody handelChange={(key, value) => this.handelChange(key, value)} validation={this.state.validateNewPatient} />}
                                    show={this.state.addNewPatient}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Add"
                                    buttonDisabled={this.props.loadingPatient}
                                    buttonFunction={() =>  this.handleAddNewPatient()}
                                />
                            }
                            {
                                this.state.moreThenAvailableUnitsModal &&
                                <ModalComponent
                                    dialogClassName="available__modal"
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Units More Than Available"
                                    modalBody="The number of inserted units exceeds the number of available units. The case will be pending confirmation from the lab, are you sure you want to continue ?"
                                    show={this.state.moreThenAvailableUnitsModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Book Now"
                                    buttonDisabled={this.props.home.addingDataLoading}
                                    buttonFunction={() => this.handleSaveBooking()}
                                />
                            }
                            {
                                this.state.deletePatientModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Delete Patient"
                                    modalBody="Are you sure you want to permanently delete this patient ?"
                                    show={this.state.deletePatientModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Delete"
                                    buttonFunction={(event) => this.deletePatient(event, this.state.deletedPatiientId)}
                                />
                            }
                            {
                                this.state.editPatientModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Edit Patient"
                                    modalBody={<CustomModalBody editPatientInfo={this.state.editPatientInfo} handelChange={(key, value) => this.handelChangeEdit(key, value)} validation={this.state.validateNewPatient} />}
                                    show={this.state.editPatientModal}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Save"
                                    buttonFunction={(event) => this.editPatient(event, this.state.editPatiientId)}
                                />
                            }
                            {
                                this.state.printModal &&
                                <ModalComponent
                                    dialogClassName="print-modal"
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle={this.state.modalHeaderText}
                                    modalBody={this.state.modalBodyText}
                                    printCase={this.state.printModal}
                                    show={this.state.printModal}
                                    caseDetails={this.props.home.caseList}
                                    handleClose={() => this.handleClose()}
                                    buttonText="Yes"
                                    isAdmin={false}
                                />
                            }
                            {
                                this.state.isOpenPickupModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Schedule Pickup"
                                    modalBody="Is the case ready for pickup?"
                                    show={this.state.isOpenPickupModal}
                                    isPickupModal={true}
                                    caseDetails={this.props.home.caseList}
                                    handleClose={() => this.handleClosePickupModal()}
                                    buttonText="Yes"
                                    buttonFunction={() => this.schedulePickup()}
                                    isAdmin={false}
                                />
                            }
                            {
                                this.state.isOpenLeaveModal &&
                                <ModalComponent
                                    modalHeaderStyle="modalHeaderDefault"
                                    headerTitle="Close form"
                                    show={this.state.isOpenLeaveModal}
                                    handleClose={() => this.handleStay()}
                                    buttonText="Leave"
                                    buttonFunction={() => this.handleClose()}
                                    isLeaveModal={true}
                                />
                            }
                        </div>
                    </div>
                    {
                        this.state.isOpenSubcaseForm ?
                            <SubcaseForm
                                caseDetails={this.props.home.caseList.caseDetails}
                                parent_id={this.state.addingBookingInfo.parent_id}
                                isAdmin={false}
                                dashboard={this.props.home}
                                dashboardData={this.props.home.patientList}
                                toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                getData={this.props.getPatient}
                                isOpenSubcaseForm={this.state.isOpenSubcaseForm}
                                addPatient={this.props.addPatient}
                                addDentist={this.props.addDentist}
                                addBooking={this.props.addBooking}
                                saveDisabled={this.props.home.addingDataLoading}
                                minDateForSubcase={this.props.caseDetails.caseList.minDateForSubcase}
                                vacationDays={this.props.vacationDays}
                                bridges={this.state.addingBookingInfo.bridges}
                                checkedTeeth={this.state.checkedTeeth}
                                makeBridge={(from,to)=>this.makeBridge(from,to)}
                            />
                            : ''
                    }
                    {
                        this.state.createSubcaseModal &&
                        <ModalComponent
                            modalHeaderStyle="modalHeaderDefault"
                            headerTitle="Create Subcase"
                            modalTitle="subcaseModalTitle modalTitle"
                            infoModal={true}
                            modalBody={<SubcaseModalBody
                                toggleCasesDropdown={this.toggleCasesDropdown}
                                isOpenCasesDropdown={this.state.isOpenCasesDropdown}
                                toggleSubcaseFormModal={this.toggleSubcaseFormModal}
                                eventList={this.parentCasesList}
                            />}
                            dialogClassName={"subcase__modal__dialog"}
                            show={this.state.createSubcaseModal}
                            handleClose={() => this.handleClose()}
                        />
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = dispatch => {
    return {
        imageUpload: dispatch.imageUploadReducer,
        calendarRange: dispatch.global.calendarRange,
        hasLicense: dispatch.auth.currentUser.license,
        createdByAdmin: dispatch.auth.currentUser.created_by === "admin",
        vacationDays :dispatch.adminDashboard.vacationDays,
        vacationDaysLoading: dispatch.adminDashboard.vacationDaysRequestLoading,
        loadingPatient: dispatch.home.loadingPatient,
        home: dispatch.home,
        caseDetails: dispatch.caseDetails,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addPatient: (data) => { dispatch(addPatient(data)); },
        addBooking: (data) => { dispatch(addBooking(data)); },
        getPatient: (data) => { dispatch(getPatient(data)); },
        deletePatient: (patientId, data) => { dispatch(deletePatient(patientId, data)); },
        editPatient: (data) => { dispatch(editPatient(data)); },
        updateGuide: () => { dispatch(updateGuide()); },
        getCase: (caseId) => { dispatch(getCase(caseId)); },
        addPickup: (caseId, isPickup) => { dispatch(addPickup(caseId, isPickup)); },
        getParentCases: () => { dispatch(getParentCases()); },
        getVacationDays: () => dispatch(getVacationDaysRequest(moment(new Date()).format('YYYY-MM-DD'))),
        onDateChange: (data) => dispatch(setDate(data)),
        startImageUploading: (data) => {
            dispatch(startImageUploading(data))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/Layouts/User/Home/index.js